/**
  * @class meleMap_circle
  * @description
  *
  * # Purpose
  * Implaments CIRCLE shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

import meleMap_shape from '../meleMap_shape.js'
const melemap_lib = require('../meleMap_lib.js')

export default class meleMap_circle extends meleMap_shape {
  static shape() { return 'C' }

  redrawShape() {
    if(this._points.length<2) { return this.deleteShape() }

    const radius = L.latLng(this._points[0]).distanceTo(this._points[1])
    if(this._shape) {
      this._shape.setLatLng(this._points[0])
      this._shape.setRadius(radius)
    }else{
      this._shape = L.circle(this._points[0], { radius, pane: this._props.pane || melemap_lib.DEFAULT_PANE }).addTo(this._map)
    }
    this.configureShape()
  }

  calculateCenter() {
    this._center = this._points.length>0 ? this._points[0] : ''
    return this._center
  }

  shape() {
    return 'C,'+this._points.slice(0, 2).map(point=>melemap_lib.point2geohash(point)).join(',')
  }

  addPoint(point) {
    if(this._points.length>=2) { this._points=[] }
    this._points.push(point)
    delete this._center
    this.redrawShape()
    this.redrawMarker()
    // prepare guiding circle if we have just one point
    if(this._points.length===1) {
      this._guide = L.circle(this._points[0], { radius: 1, pane: melemap_lib.DRAW_PANE }).addTo(this._map)
      this._guide._path.setAttribute('marker', 'guide')
    }else if(this._guide) {
      this._map.removeLayer(this._guide)
      this._guide = null
    }
  }

  guide(point) {
    if(this._guide) {
      const radius = L.latLng(this._points[0]).distanceTo(point)
      this._guide.setRadius(radius)
    }
  }

  // returns bounds of the shape; special fix for circle
  bounds() {
    let bounds = null
    try{
      this._shape._project()
      bounds = this._shape.getBounds()
    }catch(e) {}
    return bounds
  }
} // class meleMap_circle
